import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-field center d-flex align-center",
    style: _normalizeStyle(_ctx.textStyle)
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.box.properties.text), 1)
  ], 4))
}